import { DefaultProjectImage } from 'src/components/atoms/DefaultProjectImage'
import { PaginationRebrand } from 'src/components/molecules/PaginationRebrand'
import { ProjectCardRebrand } from 'src/components/molecules/ProjectCardRebrand'

import { GetProjectListingQuery } from 'src/config/generated/graphql'
import { viewProjectPath } from 'src/config/paths'
import { env } from 'src/env/client.mjs'
import { usePagination } from 'src/hooks/usePagination'

type ProjectGridViewRebrandProps = {
  projects: GetProjectListingQuery | undefined
}

const ProjectGridViewRebrand = ({ projects }: ProjectGridViewRebrandProps) => {
  const { currentPage, limit, onPageClick } = usePagination({
    limit: 9
  })

  return (
    <>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 md:flex-wrap flex-col md:flex-row gap-5 auto-rows-auto'>
        {projects?.Projects.map(project => (
          <ProjectCardRebrand
            key={project.Id}
            imageUrl={
              project.PublicPage
                ? `${env.NEXT_PUBLIC_ASSETS_DOMAIN}/${project.Hero}`
                : undefined
            }
            name={project.Name}
            location={
              [project.District?.Name, project.Region?.Name]
                .filter(Boolean)
                .join(', ') || undefined
            }
            treeCount={
              project.Applications_aggregate.aggregate?.sum?.Approved ||
              undefined
            }
            href={
              project.Uri
                ? viewProjectPath({ routeParams: { uri: project.Uri } })
                : undefined
            }
          />
        ))}
      </div>
      <div className='flex-row flex-wrap flex justify-between'>
        <PaginationRebrand
          page={currentPage}
          pageSize={limit}
          onChange={(page: number) => onPageClick(page)}
          count={projects?.Count.aggregate?.count || 0}
        />
        <div className='flex flex-row gap-4 items-center'>
          <DefaultProjectImage className='w-[40px] h-[40px] rounded-full' />
          Planting projects without publicly displayed pages.
        </div>
      </div>
    </>
  )
}

export default ProjectGridViewRebrand
